import React from 'react'
import { Link } from 'react-router-dom'
import { useContent } from '../../services'
import twoBg from '../../assets/images/background/image-5.jpg';
import threebg from '../../assets/images/background/image-6.jpg';
import bgfive from '../../assets/images/background/image-5.jpg'
import bg12 from '../../assets/images/background/bg-12.png'
import signaturetwo from '../../assets/images/resource/signature-2.png'
import bg13 from '../../assets/images/background/bg-13.png'

function Winningchef() {
    const { data, loading } = useContent('aboutContent');

    if (loading || !data) return null;

    const { chefSection, eventSection } = data.winningChef;

    return (
        <>
            <section className="fluid-section">
                <div className="outer-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-layer" style={{ backgroundImage: `url(${twoBg})` }}></div>
                                <div className="image"><img src={bgfive} alt="" /></div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="right-bg"><img src={bg12} alt="" title="" /></div>
                            <div className="inner clearfix wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle"><span>{chefSection.subtitle}</span></div>
                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>
                                        <h2>{chefSection.title}</h2>
                                        <div className="text">{chefSection.text}</div>
                                    </div>
                                    <div className="info">
                                        <div className="signature"><img src={signaturetwo} alt="" title="" /></div>
                                        <div className="author">{chefSection.author}</div>
                                    </div>
                                    <div className="link-box">
                                        <Link to={chefSection.ctaLink} className="theme-btn btn-style-two clearfix">
                                            <span className="btn-wrap">
                                                <span className="text-one">{chefSection.ctaText}</span>
                                                <span className="text-two">{chefSection.ctaText}</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="fluid-section alternate">
                <div className="outer-container">
                    <div className="row clearfix">

                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-layer" style={{ backgroundImage: `url(${threebg})` }}></div>
                                <div className="image"><img src={threebg} alt="" /></div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="left-bg"><img src={bg13} alt="" title="" /></div>
                            <div className="inner clearfix wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle"><span>{eventSection.subtitle}</span></div>

                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>

                                        <h2>{eventSection.title}</h2>
                                        <div className="text">{eventSection.text}</div>
                                    </div>
                                    <div className="link-box">
                                        <Link to={eventSection.ctaLink} className="theme-btn btn-style-two clearfix">
                                            <span className="btn-wrap">
                                                <span className="text-one">{eventSection.ctaText}</span>
                                                <span className="text-two">{eventSection.ctaText}</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Winningchef
